import { render, staticRenderFns } from "./crudStoreDeliveries.vue?vue&type=template&id=b8ddf4c8&"
import script from "./crudStoreDeliveries.vue?vue&type=script&lang=js&"
export * from "./crudStoreDeliveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports